import {useEffect} from 'react'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePostAccountSeedTicketGive = (
	seedTicketTypeIdxRef,
	accountIdx,
	numberRef
) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [userRole] = useRoleCookie()
	const [, setAlert] = useAlertModalAtom()

	const clickEvent = () => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/account/${accountIdx}/seed-ticket`

		fetchRequest('POST', url, {
			seed_ticket_type_idx: seedTicketTypeIdxRef?.current,
			number: numberRef?.current?.value,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('지급되었습니다.')
				break
			case 400:
				if (fetchResult?.data?.error_code === 'seed_ticket_type_idx')
					setAlert('시드권 종류 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 계정 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'number')
					setAlert('개수 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('계정 데이터가 존재하지 않습니다.')
				if (fetchResult?.data?.error_code === 2)
					setAlert('시드권 종류 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [clickEvent]
}

export default usePostAccountSeedTicketGive
